var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-select-picker',{ref:"outletPicker",attrs:{"title":"分配至网点","clear":false,"height":"60vh","search":{async: true},"disabled":_vm.disableOptions},on:{"search":_vm.searchOutlet,"resolve":_vm.resolveHandle},scopedSlots:_vm._u([{key:"option",fn:function({data, selected, disabled}){return [_c('select-option',{attrs:{"name":data.name,"info":[
				`负责人：${data.data.principal_user_name || '-'}`
			],"selected":selected,"disabled":disabled}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }